import BitrateMonitor from './bitrate-monitor';
import StatsEmit from './stats-emit';

const stats = new StatsEmit();
stats.bitrateMonitor = new BitrateMonitor();

export { stats };

export default (ctx, inject) => {
  inject('stats', stats);
};
